import { Component, Input, ViewChild } from '@angular/core';
import { BulkSelectEmployeeDialogComponent } from '@app/components/dialogs/bulk-select-employee-dialog/bulk-select-employee-dialog.component';
import { AnalyticEvents } from '@app/enums';
import { HiringTeamMember } from '@app/modules/applicant-tracker/interfaces/hiring-team-member.interface';
import { AnalyticService, AuthService } from '@app/services';

import { EmploymentTypeDisplayOptions } from '@app/types/translatables/employment-type-display.options';
import { BaseForm } from '@forms/base.form';
import { JobPosting } from '@models/recruiting/job-posting.model';

@Component({
    selector: 'app-job-posting-store-basic-information',
    templateUrl: './job-posting-store-basic.form.html',
})
export class JobPostingStoreBasicForm extends BaseForm {
    @Input() jobPosting: JobPosting;
    @ViewChild('employeeSelect', { static: true }) employeeSelect: BulkSelectEmployeeDialogComponent;

    employmentTypesDisplay = EmploymentTypeDisplayOptions;

    constructor(
        public auth: AuthService,
        private analyticService: AnalyticService
    ) {
        super();
    }

    updateHiringTeamAssign(hiringTeamMembers: HiringTeamMember[]): void {
        this.analyticService.trackEvent(AnalyticEvents.RecruitingJobPostingCreateHiringTeam);
        this.jobPosting.hiringTeamAssign = hiringTeamMembers.map(
            (hiringTeamMember: HiringTeamMember) => hiringTeamMember.employee
        );
    }
}
